module.exports = __webpack_public_path__ + "static/media/icon-baby-grey-little.da78c01d.svg";